@if (items().length === 0) {
  <span class="ui-resource-summary__empty">—</span>
} @else {
  <div class="ui-resource-summary">
    @for (category of items(); track category.id) {
      <section class="ui-resource-summary__category">
        <p class="ui-resource-summary__line">
          <span class="ui-resource-summary__label">{{ 'agents.tasks.table.category' | uiLabelTranslate }}:</span>
          <span class="ui-resource-summary__value">{{ category.name }}</span>
        </p>

        @for (product of category.products; track product.id) {
          @let productKeyValue = productKey(category.id, product.id);
          <div class="ui-resource-summary__product">
            <p class="ui-resource-summary__line">
              <span class="ui-resource-summary__label">{{ 'agents.tasks.table.product' | uiLabelTranslate }}:</span>
              <span class="ui-resource-summary__value">{{ product.name }}</span>
            </p>

            @if (product.variants.length <= 1) {
              @for (variant of product.variants; track variant.id) {
                <div class="ui-resource-summary__variant">
                  <p class="ui-resource-summary__line">
                    <span class="ui-resource-summary__label">{{ 'agents.tasks.table.variant' | uiLabelTranslate }}:</span>
                    <span class="ui-resource-summary__value">{{ variant.name }}</span>
                  </p>
                  <p class="ui-resource-summary__meta">{{ 'agents.tasks.table.quantity' | uiLabelTranslate }}: {{ formatQuantity(variant) }}</p>
                  <p class="ui-resource-summary__meta">{{ 'agents.tasks.table.sellingPrice' | uiLabelTranslate }}: {{ formatSellingPrice(variant.sellingPrice) }}</p>
                </div>
              }
            } @else {
              <button
                type="button"
                class="ui-resource-summary__toggle"
                [attr.aria-expanded]="isExpanded(productKeyValue)"
                (click)="toggleProduct(productKeyValue)"
              >
                <span class="ui-resource-summary__toggle-copy">
                  <span class="ui-resource-summary__label">{{ 'agents.tasks.activityTable.variants' | uiLabelTranslate }}:</span>
                  <span class="ui-resource-summary__value">{{ product.variants.length }}</span>
                </span>
                <span class="material-symbols-rounded ui-resource-summary__toggle-icon" aria-hidden="true">
                  {{ isExpanded(productKeyValue) ? 'expand_less' : 'expand_more' }}
                </span>
              </button>

              @if (isExpanded(productKeyValue)) {
                <div class="ui-resource-summary__variant-list">
                  @for (variant of product.variants; track variant.id) {
                    <div class="ui-resource-summary__variant">
                      <p class="ui-resource-summary__line">
                        <span class="ui-resource-summary__label">{{ 'agents.tasks.table.variant' | uiLabelTranslate }}:</span>
                        <span class="ui-resource-summary__value">{{ variant.name }}</span>
                      </p>
                      <p class="ui-resource-summary__meta">{{ 'agents.tasks.table.quantity' | uiLabelTranslate }}: {{ formatQuantity(variant) }}</p>
                      <p class="ui-resource-summary__meta">{{ 'agents.tasks.table.sellingPrice' | uiLabelTranslate }}: {{ formatSellingPrice(variant.sellingPrice) }}</p>
                    </div>
                  }
                </div>
              }
            }
          </div>
        }
      </section>
    }
  </div>
}
